import dayjs from "dayjs";

// Fetch available timeframes from database for a selected calendar date, and show the list in a modal.
window.fetchAvailableTimeframes = function (orderId) {
  let selectedDate = document.getElementById("meeting-date").value;
  let apiUrl = `/availabilities/get_available_timeframes?selected_date=${selectedDate}&order_id=${orderId}`;

  fetch(apiUrl, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(response => response.json())  
    .then(data => {
      populateTimeModal(data.amTimeslots, data.pmTimeslots);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function buildRadioInputs(timeslots, timingsList, indexFrom) {
  if (timeslots.length > 0) {
    timeslots.forEach((timing, index) => {
      const startTime = timing[0] ? formatTime(timing[0].split(' ')[1]) : '';

      let listItem = document.createElement('li');

      // Create radio button
      let radioInput = document.createElement('input');
      radioInput.type = 'radio';
      radioInput.id = 'timing' + (index + indexFrom);
      radioInput.name = 'timing';
      radioInput.value = timing[0]; // Storing both start and end time

      // Attach event listener to radio button
      radioInput.addEventListener('change', function() {
        updateSelectedTime(this.value); 
      });

      // Create label for radio button
      let label = document.createElement('label');
      label.htmlFor = 'timing' + (index + indexFrom);
      label.textContent = `${startTime}`;
      label.classList.add('ml-1');

      listItem.appendChild(radioInput);
      listItem.appendChild(label);
      timingsList.appendChild(listItem);
    })
  }
}

function populateTimeModal(amTimeslots, pmTimeslots) {
  const instructionTimingsList = document.getElementById('instructionTimingsList');
  const headTimingsList = document.getElementById('headTimingsList');
  const amTimingsList = document.getElementById('amTimingsList');
  const pmTimingsList = document.getElementById('pmTimingsList');
  amTimingsList.innerHTML = ''; // Clear existing list items
  pmTimingsList.innerHTML = ''; // Clear existing list items

  buildRadioInputs(amTimeslots, amTimingsList, 0);
  buildRadioInputs(pmTimeslots, pmTimingsList, amTimeslots.length);

  if (amTimeslots.length === 0 && pmTimeslots.length === 0) {
    instructionTimingsList.style.display = "none"
    headTimingsList.style.display = "block";
  } else {
    instructionTimingsList.style.display = "block"
    headTimingsList.style.display = "none";
  }

  $(document).ready(function(){
    $(`#timingsModal`).modal("show");
  });
}


function formatTime(timeString) {
  // Append a standard date to the time string
  const standardDate = '2023-01-01'; 
  const dateTimeString = `${standardDate}T${timeString}`;
  return dayjs(dateTimeString).format('h:mm A') // 'h:mm a' is the format string for 12-hour time format with AM/PM
}

function updateSelectedTime(selectedTime) {
  // Split the selectedTime by comma to separate start and end times
  let times = selectedTime.split(',');
  if (times.length === 1) {
    let currDate = document.getElementById("meeting-date").value
    // Format both start and end times
    let startDateTime = times[0].split(' ') 
    let formattedStartTime = formatTime(startDateTime[1])
    let formattedTimeInterval =  `${currDate} ${formattedStartTime}`;

    document.getElementById('displaySelectedTime').textContent = formattedTimeInterval;
    document.getElementById('selectedTimeField').value = formattedTimeInterval;

  } else {
    console.log("Incorrect time format selected", selectedTime);
  }
}

// Text Button to clear the selected datetime.
window.clearSelectedDatetime = function () {
  const dateInput = document.getElementById('meeting-date');
  const timeDisplay = document.getElementById('displaySelectedTime');
  dateInput.value = ''; // Clear the date
	timeDisplay.textContent = '';
}

